import styled from 'react-emotion';
import { ActionButton } from '../buttons';
import { themeGet } from 'styled-system';

// @flex
// @padding
export const LoginButton = styled(ActionButton)``;

export const LoginWelcome = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media screen and (max-width: 40em) {
    margin-bottom: ${themeGet('space.3')}px;
  }
`;

export const LoginWelcomeHeading = styled('h3')`
  color: ${themeGet('colors.blueDarker')};
  font-size: 20px;
  text-transform: uppercase;
  font-weight: 700;
`;

export const LoginWelcomeSubHeading = styled('h4')`
  color: ${themeGet('colors.greyDarker')};
  font-size: 16px;
  font-weight: 300;
  margin-top: ${themeGet('space.2')};

  > a {
    color: ${themeGet('colors.redLight')};
  }
`;

// @flex
// @padding
export const LoginInput = styled('input')`
  flex: auto;
  appearance: none;
  outline: 0;
  border: 2px solid ${themeGet('colors.greyLighter')};
  border-left: 5px solid ${themeGet('colors.greyLight')};
  padding: ${themeGet('space.4')}px ${themeGet('space.4')}px;
  border-radius: 4px;
  background: transparent;
  cursor: text;
  height: inherit;
  width: 100%;
  font-size: 16px;
  color: ${themeGet('colors.black')};

  &:focus {
    border: 2px solid ${themeGet('colors.redLight')};
    border-left: 4px solid ${themeGet('colors.redLight')};
  }

  &::placeholder {
    color: ${themeGet('colors.grey')};
    font-size: 16px;
    font-weight: 300;
  }
`;

// @flex
export const LoginLabel = styled('label')`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const LoginAuthError = styled('span')`
  width: 100%;
  padding: ${themeGet('space.1')}px ${themeGet('space.1')}px
    ${themeGet('space.1')}px ${themeGet('space.4')}px;
  font-weight: 400;
  color: ${themeGet('colors.redLight')};
`;

// @flex
// @padding
// @margin
export const LoginWrapper = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 100%;
  max-height: 80vh;
  max-width: 80vw;

  @media screen and (max-width: 40em) {
    max-width: 95vw;
  }

  @media screen and (min-width: 52em) {
    max-width: 70vw;
  }

  @media screen and (min-width: 64em) {
    max-width: 95vw;
  }
`;

export const LeftLoginBody = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  background-color: #fff;
  padding: ${themeGet('space.5')}px ${themeGet('space.5')}px;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
  border-radius: 4px;

  @media screen and (min-width: 52em) {
    flex: 0 0 33vw;
  }
`;

export const RightLoginBody = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: #fff;
  margin-left: 16px;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  overflow-x: hidden;

  @media screen and (max-width: 52em) {
    display: none;
  }
`;

export const LoginForm = styled('form')`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  justify-content: center;
  background: white;

  @media screen and (min-width: 52em) {
    padding: ${themeGet('space.4')}px;
  }

  > * {
    margin: ${themeGet('space.2')}px 0;
  }
`;

export const AdvantagesWrapper = styled('div')`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: ${themeGet('space.6')}px;

  @media screen and (max-width: 64em) {
    padding: ${themeGet('space.5')}px;
  }
`;

export const ContentWrapper = styled('div')`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const AdvantageDrawingWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  border-bottom-width: 5px;
  border-bottom-style: solid;
  border-top-width: 5px;
  border-top-style: solid;
  border-radius: 4px;
  padding: ${themeGet('space.2')}px;
`;

export const DrawingGreen = styled(AdvantageDrawingWrapper)`
  background: ${themeGet('colors.greenLightest')};
  border-bottom-color: ${themeGet('colors.green')};
  border-top-color: ${themeGet('colors.green')};
`;

export const DrawingYellow = styled(AdvantageDrawingWrapper)`
  background: ${themeGet('colors.yellowLighter')};
  border-bottom-color: ${themeGet('colors.yellowDark')};
  border-top-color: ${themeGet('colors.yellowDark')};
`;

export const DrawingBlue = styled(AdvantageDrawingWrapper)`
  background: ${themeGet('colors.blueLightest')};
  border-bottom-color: ${themeGet('colors.blue')};
  border-top-color: ${themeGet('colors.blue')};
`;

export const AdvantageTextWrapper = styled('div')`
  flex: 1;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${themeGet('colors.greyLight')};
  margin-left: 5px;
  border-radius: 4px;
  border-bottom: 5px solid ${themeGet('colors.greyDarker')};
  border-top: 5px solid ${themeGet('colors.greyDarker')};
  padding: ${themeGet('space.6')}px;

  @media screen and (max-width: 64em) {
    padding: ${themeGet('space.3')}px;
  }

  p {
    font-weight: 300;
    font-size: 18px;
    color: ${themeGet('colors.greyDarker')};
    line-height: 2;
    width: 100%;

    span {
      font-weight: 400;
      text-transform: uppercase;
      color: ${themeGet('colors.green')};
    }
  }
`;

export const TextWrapperGreen = styled(AdvantageTextWrapper)`
  p {
    span {
      color: ${themeGet('colors.green')};
    }
  }
`;

export const TextWrapperYellow = styled(AdvantageTextWrapper)`
  p {
    span {
      color: ${themeGet('colors.yellow')};
    }
  }
`;

export const TextWrapperBlue = styled(AdvantageTextWrapper)`
  p {
    span {
      color: ${themeGet('colors.blue')};
    }
  }
`;



// WEBPACK FOOTER //
// ../shop_main/components/login/style.js